import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { IsSalesTouchSourceParameterAvailableResolver } from './is-sales-touch-source-parameter-available.nba-condition-resolver';
import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

@Injectable()
export class IsSalesTouchSourceParameterNotAvailableResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsSalesTouchSourceParameterNotAvailable;

  public constructor(private readonly route: ActivatedRoute) {}

  /**
   * @returns (observable of) true if sales touch query parameter 'source' is NOT available and has a correct value, false otherwise
   */
  public resolve$(): Observable<boolean> {
    return new IsSalesTouchSourceParameterAvailableResolver(this.route).resolve$().pipe(map(res => !res));
  }
}
